const localStorageCheck = () => Boolean(localStorage.getItem('birdScore'))

export default localStorageCheck
